import React, { useState, useRef } from "react";
import "../Services/Services.css";
import mdi_list from "../Assets/mdi_list";
import { IoIosArrowDown } from "react-icons/io";
import image1 from "../Assets/inhalation.png";
import image2 from "../Assets/asthma.png";
import image3 from "../Assets/inhaler (1).png";
import dpis_list from "../Assets/dpis_list";
import nasal_spre_list from "../Assets/nasal_spre_list";
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

function Services() {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleItemClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const [activeIndex1, setActiveIndex1] = useState(null);
  const handleItemClick1 = (index) => {
    setActiveIndex1((prevIndex) => (prevIndex === index ? null : index));
  };

  const [activeIndex2, setActiveIndex2] = useState(null);
  const handleItemClick2 = (index) => {
    setActiveIndex2((prevIndex) => (prevIndex === index ? null : index));
  };

  const AccordionItem = ({ question, answer, isOpen, onClick }) => {
    const contentHeight = useRef();
    return (
      <div className="wrapper">
        <button
          className={`question-container ${isOpen ? "active" : ""}`}
          onClick={onClick}
        >
          <div>
            <p className="question-content">{question}</p>
          </div>
          <div>
            <IoIosArrowDown className={`arrow ${isOpen ? "active" : ""}`} />
          </div>
        </button>

        <div
          ref={contentHeight}
          className="answer-container"
          style={isOpen ? { height: contentHeight.current } : { height: "0px" }}
        >
          <p className="answer-content">{answer}</p>
        </div>
      </div>
    );
  };

  return (
    <>
    <Header/>
      <div className="services">
        <h2>
          Our Services
          <hr />
        </h2>
        <div className="services-description">
          Speciality pharmaceutical Testing services to support developmental
          programs, regulatory submissions, stability program, batch Release
          testing and post approval testing to accelerate partners Filing
          Process
        </div>
        <div className="services-cards-div">
          <div className="services-card">
            <img src={image1} alt="icon" className="services-card-icon" />
            <p className="services-card-title">Metered Dose Inhalers</p>
            <p className="services-card-description">
              A metered-dose inhaler (MDI) is a device that delivers a specific
              amount of medication to the lungs, in the form of a short burst of
              aerosolized medicine administered by the patient via inhalation.
            </p>
          </div>
          <div className="services-card odd-card">
            <img src={image2} alt="icon" className="services-card-icon" />
            <p className="services-card-title">Dry Powder Inhaler</p>
            <p className="services-card-description">
              A dry-powder inhaler (DPI) is a device that delivers medication to
              the lungs in the form of a dry powder.
            </p>
          </div>
          <div className="services-card">
            <img src={image3} alt="icon" className="services-card-icon" />
            <p className="services-card-title">Nasal Spray</p>
            <p className="services-card-description">
              A Nasal spray works via actuation of a nasal spray bottle, used to
              deliver medication via the nostrils.
            </p>
          </div>
        </div>

        <div className="services-offered">
          <h3>
            List of services offered <hr />
          </h3>
          <ul>
            <li>Analytical Method Development</li>
            <li>Analytical Method Validation</li>
            <li>Analytical Method Transfer</li>
            <li>
              Analytical Method Verification (In Case of Compendial/ Validated
              Method)
            </li>
            <li>Reverse Engineering/ De-Formulation/ Q1-Q2</li>
            <li>Actuator Screening Study</li>
            <li>In-vitro Bio Equivalence</li>
            <li>Drug Product Characterization as per CMC Guidance</li>
            <li>Device Selection and Characterization</li>
            <li>Drug Delivery Through Spacers</li>
            <li>Development & GMP Batch Analysis</li>
            <li>QC Batch Release</li>
            <li>
              Stability Testing (Developmental, Registration, commercial &
              market extension stability studies)
            </li>
            <li>
              Supporting in Identifying Q3 Parameters For ensuring Bio-success
            </li>
            <li>RLD Lot selection for Biostudies</li>
            <li>Device Characterization</li>
          </ul>
        </div>

        <div>
          <div className="services-functionality">
            <div className="services-functionality-div1">
              <p>
                List of Services for MDIs
                <hr />
              </p>
              <ul className="services-functionality-div1-list">
                <li>Specifications for Drug Product</li>
                <li>Characterization studies</li>
                <li>IVIVC Studies</li>
              </ul>
            </div>
            <div className="services-functionality-div2">
              {mdi_list.map((item, index) => (
                <AccordionItem
                  key={index}
                  question={item.question}
                  answer={item.answer}
                  isOpen={activeIndex2 === index}
                  onClick={() => handleItemClick2(index)}
                />
              ))}
            </div>
          </div>

          <div className="services-functionality services-functionality-div-odd">
            <div className="services-functionality-div2">
              <div className="dpis-list-accordion">
                {dpis_list.map((item, index) => (
                  <AccordionItem
                    key={index}
                    question={item.question}
                    answer={item.answer}
                    isOpen={activeIndex === index}
                    onClick={() => handleItemClick(index)}
                  />
                ))}
              </div>
            </div>
            <div className="services-functionality-div1">
              <p>
                Services offered for DPIs
                <hr />
              </p>
              <ul className="services-functionality-div1-list">
                <li>Specifications for Drug Product</li>
                <li>Characterization studies</li>
                <li>IVIVC Studies</li>
              </ul>
            </div>
          </div>

          <div className="services-functionality">
            <div className="services-functionality-div1">
              <p>
                Services offered for Nasal Sprays
                <hr />
              </p>
              <ul className="services-functionality-div1-list">
                <li>Specifications for Drug Product</li>
                <li>Characterization studies</li>
                <li>
                  In-Vitro Bio-Equivalence with Statistical analysis (For
                  submission)
                </li>
                <li>Innovative In-Vitro testing</li>
              </ul>
            </div>
            <div className="services-functionality-div2">
              {nasal_spre_list.map((item, index) => (
                <AccordionItem
                  key={index}
                  question={item.question}
                  answer={item.answer}
                  isOpen={activeIndex1 === index}
                  onClick={() => handleItemClick1(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
}
export default Services;
